import { storeAuditService } from 'features/order/store-audit/infra';
import { useEffect, useState } from 'react';
import {
  checkoutRTCase,
  defaultValueHandoffDetail,
} from '../../../../business/order/rt';
import { OrderDeliveryDetailAnalytics } from '../../../../business/order/rt/analytics';

export function useDeliveryDetail({
  code,
  orderId,
  storeId,
  orderState,
  isMandatory,
  isInKanban,
  isBagQuantitySet,
  hasDeliveryDetailMessage,
  hasDefectRate,
}) {
  const {
    defaultValue,
    maxQuantityOfPackages,
    status,
    updateHandoffDetail,
    getHandoffDetail,
    getV2Orders,
  } = checkoutRTCase({ code });
  const [quantityOfPackages, setQuantityOfPackages] = useState(
    defaultValue.quantityOfPackages,
  );
  const [hasDrinksOutside, setHasDrinksOutside] = useState(
    defaultValue.hasDrinksOutside,
  );
  const _orderAudit = storeAuditService.getOrderAudit(orderId);
  const _isDisabledByDefectRate =
    isMandatory && hasDefectRate && !_orderAudit?.isAllChecked;

  useEffect(() => {
    if (orderId && !isInKanban) {
      getHandoffDetail({ orderId });
    }
  }, []);

  useEffect(() => {
    if (!status.isNotReadyToSetData) {
      setQuantityOfPackages(
        isBagQuantitySet
          ? defaultValue.quantityOfPackages
          : defaultValueHandoffDetail.quantityOfPackages,
      );
      setHasDrinksOutside(
        isBagQuantitySet
          ? defaultValue.hasDrinksOutside
          : defaultValueHandoffDetail.hasDrinksOutside,
      );
    }
  }, [defaultValue]);

  function handleDownQuantityOfPackages() {
    if (quantityOfPackages === 1 || Number.isNaN(quantityOfPackages)) return;
    setQuantityOfPackages(bags => --bags);
  }

  function handleUpQuantityOfPackages() {
    if (quantityOfPackages >= maxQuantityOfPackages) return;
    setQuantityOfPackages(bags => (Number.isNaN(bags) ? 1 : ++bags));
  }

  function handleHasDrinksOutside(hasDrinksOutside) {
    setHasDrinksOutside(hasDrinksOutside);
  }

  function handleRetry() {
    updateHandoffDetail({
      orderId,
      storeId,
      hasDrinksOutside,
      quantityOfPackages,
    });
  }

  function handleSubmit() {
    try {
      updateHandoffDetail({
        orderId,
        storeId,
        hasDrinksOutside,
        quantityOfPackages,
      });
      OrderDeliveryDetailAnalytics.whenHandOffBagsAndDrinksInput(
        { orderId },
        {
          numberOfBags: quantityOfPackages,
          outsideDrink: hasDrinksOutside ? 'outside' : 'inside',
          partnerOrderState: orderState,
          isMandatory,
          rtWaiting: hasDeliveryDetailMessage,
        },
      );
      if (isInKanban) setTimeout(() => getV2Orders(), 1_000);
    } catch (error) {
      console.error(error);
    }
  }

  return {
    defaultValue,
    maxQuantityOfPackages,
    quantityOfPackages,
    handleDownQuantityOfPackages,
    handleUpQuantityOfPackages,
    hasDrinksOutside,
    handleHasDrinksOutside,
    handleRetry,
    isUpdateLoading: status.updateInprogress,
    isUpdateSuccess: status.isUpdated,
    isUpdateDenied: status.isUpdateDenied,
    isGetLoading: status.getInProgress,
    isInputMandatory:
      isMandatory &&
      !isBagQuantitySet &&
      !status.isUpdated &&
      !status.updateInprogress &&
      !isInKanban,
    isDisabled:
      hasDrinksOutside === defaultValueHandoffDetail.hasDrinksOutside ||
      Number.isNaN(quantityOfPackages) ||
      _isDisabledByDefectRate,
    handleSubmit,
    isDefectProductsChecked: _orderAudit?.isAllChecked,
  };
}
